export const convertToBase64 = <T>(json: T) =>
  typeof json !== 'undefined'
    ? btoa(
        encodeURIComponent(JSON.stringify(json)).replace(/%([0-9A-F]{2})/g, (match, p1) =>
          String.fromCharCode(parseInt(p1, 16))
        )
      )
    : ''
